import { useSearchParams } from 'react-router-dom';
import DuplicateForeCastBase from './DuplicateForeCastBase';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserToken, setDisplayErrorSnackBar } from '../../../../../features/userSlice';
import { forecastersEndPointLogic } from '../../../../../logic/AssetManagement/Forecasters/forecastersEndPointLogic';
import store from '../../../../../store';
import ForecastSkeleton from '../CreateNewForeCast/ForecastSkeleton';
import { DuplicateForecastFTD } from './DuplicateForecastFTD';
import { DuplicateForecastGrowth } from './DuplicateForecastGrowth';
import { DuplicateForecastProfit } from './DuplicateForecastProfit';
import { Paper } from '@mui/material';

const DuplicateForeCast = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const dispatch = useDispatch();
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const selectedSite = searchParams.get("selectedSite") as any;
  const selectedYear = searchParams.get("selectedYear");
  const selectedMetaSharedUid = searchParams.get("metaSharedUid");
  const forecastersList = useSelector((state: any) => state.forecasters?.forecastersList);
  const selectedForecaster = forecastersList?.find((forecaster: any) => forecaster.meta_shared_uid === selectedMetaSharedUid);
  const [dataLoaded, setDataLoaded] = useState(false);
  const QUERY_ID = "5699409840963584";

  useEffect(() => {
    if (selectedSite && selectedYear) {
      setIsLoading(true);
      setDataLoaded(false);
      setShowContent(false);
      const fetchForecastData = async () => {
        try {
          await forecastersEndPointLogic.getForecastersList(selectedSite, oauthTokenHeader, selectedYear, dispatch)
          // await forecastersEndPointLogic.getForecastersList(selectedSite, oauthTokenHeader, selectedYear, dispatch)
          await forecastersEndPointLogic.getForecasterLastTwelveMonthsData(oauthTokenHeader, QUERY_ID, selectedSite, dispatch)
          setDataLoaded(true);
        } catch (error: any) {
          store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || 'Error while fetching data. Please try again later.', type: 'error' }));
        } finally {
          setIsLoading(false);
        }
      };
      fetchForecastData();
    }
    // eslint-disable-next-line
  }, [selectedSite, selectedYear, dispatch]);
  

  const ComponentForForcastCreation:any = {
    1: DuplicateForecastFTD,
    2: DuplicateForecastGrowth,
    3: DuplicateForecastProfit
  };

  const renderComponent = (type: number) => {
    const Component = ComponentForForcastCreation[type];
    return Component ? (<Component selectedForecaster={selectedForecaster} loading={loading} setLoading={setLoading} onTableReady={() => setShowContent(true)} showContent={showContent} />) : null;
  }

  return (
    <>
      {isLoading ? (
        <ForecastSkeleton />
      ) : ""}
      {dataLoaded && !isLoading && (
        <Paper sx={{borderRadius: 1, position: "relative" }} elevation={0}>
          {showContent && (
            <DuplicateForeCastBase 
              selectedForecaster={selectedForecaster} 
              loading={loading} 
            />
          )}
          {renderComponent(selectedForecaster?.template_type) || ""}
        </Paper>
      )}
    </>
  )
}

export default DuplicateForeCast
